import { AxiosResponse } from "axios";
import { apiClient } from "../base-client";
import { createServerApiClient } from "../server-base-client";

export type PaymentIntentResponse = {
  clientSecret: string;
  paymentIntentId: string;
  total: number;
  subTotal: number;
  product: {
    id: string;
    variant: string;
    price: number;
  };
  appliedAddons: Array<{
    name: string;
    price: number;
    id: string;
  }>;
  addons: Array<{
    name: string;
    price: number;
    id: string;
  }>;
  discount?: {
    code: string;
    type: "fixed" | "percentage";
    discount: number;
  };
};

export type PaymentStatusResponse = {
  paymentIntentId: string;
  total: number;
  subTotal: number;
  product: {
    id: string;
    variant: string;
    price: number;
  };
  appliedAddons?: Array<{
    id: string;
    name: string;
    price: number;
  }>;
  discount?: {
    code: string;
    type: "fixed" | "percentage";
    discount: number;
  };
  status?: string;
};

type CreatePaymentIntentParams = {
  segmentId: string;
  product: string;
  lotSize?: string;
  email?: string;
  phone?: string;
  address?: string;
  addons?: string[];
  promotionalCode?: string;
};

type UpdatePaymentIntentParams = {
  product: string;
  lotSize?: string;
  addons?: string[];
  promotionalCode?: string;
  email?: string;
  phone?: string;
  address?: string;
  userId?: string;
};

const getApiClient = async (authToken?: string) => {
  if (authToken) {
    return await createServerApiClient(authToken);
  }
  return apiClient;
};

export async function createPaymentIntent(
  params: CreatePaymentIntentParams,
  authToken?: string,
): Promise<AxiosResponse<PaymentIntentResponse>> {
  const client = await getApiClient(authToken);

  return await client.post("payments-v2", {
    ...params,
  });
}

export async function updatePaymentIntent(
  paymentIntentId: string,
  params: UpdatePaymentIntentParams,
  authToken?: string,
): Promise<AxiosResponse<PaymentIntentResponse>> {
  const client = await getApiClient(authToken);

  return await client.patch(`payments-v2/${paymentIntentId}`, {
    ...params,
  });
}

export async function getPaymentIntentStatus(
  paymentIntentId: string,
  authToken?: string,
): Promise<AxiosResponse<PaymentStatusResponse>> {
  const client = await getApiClient(authToken);

  return await client.get(`payments-v2/${paymentIntentId}/status`);
}
